import React from "react";
import { motion } from "framer-motion";
import { Apple, Play } from "lucide-react";

export default function Download() {
    return (
        <section
            id="download"
            data-testid="download-section"
            className="relative py-20 md:py-28 overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7 }}
                    className="relative rounded-[2.5rem] overflow-hidden p-10 md:p-16 lg:p-20 text-white"
                    style={{
                        background:
                            "linear-gradient(135deg, #16A34A 0%, #0e8a3e 45%, #0B1C3A 100%)",
                    }}
                >
                    <div
                        aria-hidden
                        className="blob"
                        style={{
                            width: 420,
                            height: 420,
                            top: -120,
                            right: -120,
                            background:
                                "radial-gradient(circle, rgba(255,255,255,0.25), transparent 65%)",
                            filter: "blur(60px)",
                            opacity: 0.4,
                        }}
                    />
                    <div className="relative max-w-3xl">
                        <span className="text-xs uppercase tracking-[0.2em] font-bold text-white/80">
                            Baixe o Dentro
                        </span>
                        <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-6xl font-extrabold tracking-tight">
                            Coloque o Dentro no seu bolso.
                        </h2>
                        <p className="mt-5 text-lg text-white/85 leading-relaxed max-w-2xl">
                            Em breve disponível para iOS e Android. Baixe direto
                            nas lojas e comece a escanear seus produtos com
                            confiança.
                        </p>

                        <div className="mt-8 flex flex-wrap gap-3">
                            <a
                                href="#"
                                data-testid="download-ios-cta"
                                className="group inline-flex items-center gap-3 px-6 py-4 rounded-full bg-white text-[#0B1C3A] font-bold hover:scale-[1.03] transition-transform shadow-[0_18px_40px_-12px_rgba(0,0,0,0.35)]"
                            >
                                <Apple size={22} />
                                <span className="flex flex-col leading-none items-start">
                                    <span className="text-[10px] uppercase tracking-widest text-[#475569]">
                                        Download na
                                    </span>
                                    <span className="text-base">App Store</span>
                                </span>
                            </a>
                            <a
                                href="#"
                                data-testid="download-android-cta"
                                className="group inline-flex items-center gap-3 px-6 py-4 rounded-full bg-[#0B1C3A] text-white font-bold hover:scale-[1.03] transition-transform shadow-[0_18px_40px_-12px_rgba(0,0,0,0.45)]"
                            >
                                <Play size={20} fill="currentColor" />
                                <span className="flex flex-col leading-none items-start">
                                    <span className="text-[10px] uppercase tracking-widest text-white/60">
                                        Download no
                                    </span>
                                    <span className="text-base">Google Play</span>
                                </span>
                            </a>
                        </div>

                    </div>
                </motion.div>
            </div>
        </section>
    );
}
